var React = require('react');

function CopyLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 1 1 5.66 5.66l-9.2 9.19a2 2 0 1 1-2.83-2.83l8.49-8.48","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"transform":"translate(-1.002 -.388)"}));
}

CopyLink.defaultProps = {"width":"21.852","height":"22.611","viewBox":"0 0 21.852 22.611"};

module.exports = CopyLink;

CopyLink.default = CopyLink;
